import FeedActivity from './FeedActivity';

export default FeedActivity;
